let mapDOM = document.getElementById("leafletMap");

class LeafletMap {
  constructor() {
    this.map = null;
    this.bounds = [];
    this.zoom = parseFloat(document.querySelector(".p_leaflet__map").dataset.zoom);
  }

  async load (element) {
    return new Promise((resolve, reject) => {  
      this.map = L.map(element, {scrollWheelZoom: false});
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
        maxZoom: 18,
        detectRetina: true
      }).addTo(this.map);
      this.map.attributionControl.setPrefix('<a href="https://leafletjs.com/" target="_blank">Leaflet</a>');
      resolve();
    })
  }

  addMarker(lat, lng, img, name, address, phone) {
    let point = [lat, lng];
    this.bounds.push(point);
    return new LeafletMarker(this.map, point, img, name, address, phone);
  }

  center() {
    this.map.fitBounds(this.bounds);
    this.map.setZoom(this.zoom);
  }

  setView(lat, lng) {
    let point = [lat, lng];
    this.map.setView(point, this.zoom);
  }
}

class LeafletMarker {
  constructor(map, point, img = "", name = "", address = "", phone = "") {
    let imgContent = !!img ? `<img class="p_leaflet-popup__img" src="${img}">` : "";
    let nameContent = !!name ? `<span class="p_leaflet-popup__name">${name}</span>` : "";
    let addressContent = !!address ? `<span class="p_leaflet-popup__address">${address}</span>` : "";
    let phoneContent = !!phone ? `<span class="p_leaflet-popup__phone">${phone}</span>` : "";

    this.icon = L.divIcon({
      html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
          <path 
            fill="currentColor" 
            d="M12.003 11.73q.668 0 1.14-.475q.472-.475.472-1.143t-.475-1.14q-.476-.472-1.143-.472t-1.14.476q-.472.475-.472 1.143t.475 1.14q.476.472 1.143.472M12 21.019q-3.525-3.117-5.31-5.814q-1.786-2.697-1.786-4.909q0-3.173 2.066-5.234Q9.037 3 12 3t5.03 2.062q2.066 2.061 2.066 5.234q0 2.212-1.785 4.909q-1.786 2.697-5.311 5.814"
          />
        </svg>`,
      className: "p_leaflet__marker-icon",
      iconSize: [32, 32],
    });

    this.popup = L.popup({
      autoClose: true,
      closeOnEscapeKey: false,
      closeOnClick: false,
      closeButton: false,
      maxWidth: 200,
      className: "p_leaflet-popup"
    })
      .setContent(imgContent + nameContent + addressContent + phoneContent)
    
    this.marker = L.marker()
      .setLatLng(point)
      .setIcon(this.icon)
      .bindPopup(this.popup)
      .on('click', this.onClick)
      .addTo(map);
  }

  onClick() {
    let markerListDOM = Array.from(document.querySelectorAll(".js-leaflet-map-marker"));

    markerListDOM.forEach((item) => {
      item.classList.remove("p_leaflet__item--active");
      
      let itemLat = parseFloat(item.dataset.lat);
      let itemLng = parseFloat(item.dataset.lng);

      if (itemLat === this.getLatLng().lat && 
          itemLng === this.getLatLng().lng) {
        item.classList.add("p_leaflet__item--active");
      }
    })
  }

  setActive() {
    this.marker.openPopup();
    this.popup.getElement().classList.add("p_leaflet__item--active");
  }

  unsetActive() {
    this.marker.closePopup();
    this.popup.getElement().classList.remove("p_leaflet__item--active");
  }
}

async function initMap() {
  let map = new LeafletMap();
  let clickMarker = null;
  let itemProps = [];
  let markerListDOM = Array.from(document.querySelectorAll(".js-leaflet-map-marker"));
  
  await map.load(mapDOM);
  
  markerListDOM.forEach((item) => {      
    let marker = map.addMarker(
      item.dataset.lat, 
      item.dataset.lng, 
      item.dataset.img, 
      item.dataset.name, 
      item.dataset.address,
      item.dataset.phone
      )
    
    item.addEventListener("click", () => {
      markerListDOM.forEach((item2) => {
        item2.classList.remove("p_leaflet__item--active");
      });
      item.classList.add("p_leaflet__item--active");
      
      if (clickMarker !== null) clickMarker.unsetActive();
      
      marker.setActive();
      map.setView(item.dataset.lat, item.dataset.lng);
      clickMarker = marker;
    })
  });
  
  map.center();
}

document.addEventListener('DOMContentLoaded', function() {
  if (mapDOM !== null) {  
    initMap()
  }
})
